import { Collapse } from '@sgme/ui';
import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  isOpen: boolean;
  toggleOpen: () => void;
  canOpen: boolean;
  title: string;
};

export function CollapseErrorDetails({ isOpen, toggleOpen, canOpen, title, children }: PropsWithChildren<Props>) {
  const handleHeaderClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (canOpen) {
      toggleOpen();
    }
  };
  const selected = isOpen && canOpen ? ['details'] : [];
  return (
    <Collapse fill="fill" icon="none" size="md" activeKey={selected}>
      <Collapse.Item itemKey="details" className="card bg-lvl1">
        <Collapse.Header className="card-header  text-danger bg-danger bg-opacity-10 text-white-focus text-white-hover p-3">
          <div className="d-flex align-items-center w-100 mx-3" onClick={handleHeaderClick}>
            <i className="icon icon-sm ms-0 me-2">cancel</i>
            <span className="me-3 text-start text-break">{title}</span>
            {canOpen && (
              <span className="ms-auto fw-bold">
                <u>{isOpen ? <FormattedMessage id="hide" /> : <FormattedMessage id="details" />}</u>
              </span>
            )}
          </div>
        </Collapse.Header>
        <Collapse.Body className="card-body py-0 px-2">{canOpen && children}</Collapse.Body>
      </Collapse.Item>
    </Collapse>
  );
}
